export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6853.221d2ddf.jpg";